import { createFileRoute } from "@tanstack/react-router"
import { DashboardPage } from "@/features/operations/dashboard-page"
export const Route = createFileRoute("/_authenticated/dashboard")({ component: DashboardPage })
